import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import CampaignLanding from "@/pages/CampaignLanding";

export const Route = createFileRoute("/campaign/$slug")({ head: ({ params }) => routeMeta('Property Campaign | MNRE', 'Explore this featured MNRE property collection.', `/campaign/${params.slug}`), component: CampaignLanding });
